module.exports = __webpack_public_path__ + "media/img/basic-logo-28e3ffda8cc528071074c0da0020d648.svg";